import { motion } from "framer-motion";

const markets = ["United Kingdom", "Europe", "United States", "Middle East", "APAC"];
const sectors = [
  "Global contractors & infrastructure firms",
  "Construction technology (ConTech) platforms",
  "Enterprise SaaS companies",
  "High-growth startups & scale-ups",
];
const highlights = [
  "Built and scaled enterprise SaaS platforms used globally",
  "Led product strategy through complex, multi-stakeholder transformations",
  "Trusted product partner to CEOs, founders and boards",
  "Modernised legacy systems into AI-enabled platforms",
];

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative bg-[#080808] py-20 sm:py-28 md:py-40 border-t border-[#141414]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-8 mb-12 md:mb-24">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C5A880]" />
              <span className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#C5A880]">
                Experience / 03
              </span>
            </div>
            <h2
              data-testid="experience-heading"
              className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] lg:leading-[1.05] tracking-tight text-[#F5F5F0]"
            >
              Operating across global markets, complex platforms and{" "}
              <em className="italic text-[#C5A880]">high-stakes</em> boardrooms.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:pl-8 md:flex md:items-end">
            <p className="text-[15px] sm:text-base md:text-lg text-[#A3A39A] leading-relaxed">
              I've partnered with global contractors, infrastructure leaders,
              ConTech platforms, enterprise SaaS companies and high-growth
              startups — operating where strategy meets execution, and where
              the wrong call is expensive.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-12 md:gap-y-10 border-t border-[#1a1a1a] pt-10 md:pt-12">
          {/* Markets */}
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C5A880] mb-5 sm:mb-6">
              Markets
            </div>
            <ul className="space-y-2 sm:space-y-3">
              {markets.map((m, i) => (
                <motion.li
                  key={m}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="font-serif-display text-xl sm:text-2xl md:text-3xl font-light text-[#F5F5F0]"
                >
                  {m}
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Sectors */}
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C5A880] mb-5 sm:mb-6">
              Sectors
            </div>
            <ul className="space-y-2 sm:space-y-3">
              {sectors.map((s, i) => (
                <motion.li
                  key={s}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="text-[#D8D8D0] text-[15px] sm:text-base leading-relaxed"
                >
                  {s}
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Highlights */}
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C5A880] mb-5 sm:mb-6">
              Highlights
            </div>
            <ul className="space-y-3 sm:space-y-4">
              {highlights.map((h, i) => (
                <motion.li
                  key={h}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="flex gap-3 text-[#D8D8D0] text-[15px] sm:text-base leading-relaxed"
                  data-testid={`experience-highlight-${i}`}
                >
                  <span className="text-[#C5A880] flex-shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{h}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
